<template>
<b-col>
    <b-row>
        <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>
        <b-col>
            <otif-ecm-table
                :rows="dashboarddata"
                :columns="dashboardcolumns"
                :actions="dashboardactions"
                :paginated="false"
                :customOptions="customOptions"
                :columnlabel="columnlabel">
            </otif-ecm-table>
        </b-col>
    </b-row>
    <b-row>
        <b-col>
            <template v-if="loaded === false">          
            </template>
            <SettingsTable v-else
                :rows="ecmDeshboardSettings"
                :columns="columns"
                :customOptions="customOptions"
                @sort="sort"
                @save="save">
                <template slot="table-header">
                    <h1 class="text-center OT-table-title"></h1>
                </template>
            </SettingsTable>
        </b-col>
    </b-row>
</b-col>
</template>

<script>

import SettingsTable from '@/ecm/components/ECMSettingsTable.vue';
import ecmSettings from '@/ecm/collections/ecmconfigs.js';
import axios from 'axios';
import { showMessage} from '../../../utils/commonECM.js';
import { sortOn } from '../../../utils/commonECM.js';
import StatusColumn from '../../links/dashboardstatus.vue';
import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';

export default {
    data() {
        return {
            ecmResourceStrings: require('../../../utils/resourceECM.js'),   
            sortDir:'asc',
            configs: [],
            messageDlg:false,
            ecmSettings: new ecmSettings({paginated: false }),
            loaded: false,
            editAction: (row, rowNumber) => {
                this.editRule(row,rowNumber);
            },
            tabname : this.$parent.$root._router.history.current.meta.label,
            path : this.$parent.$root._router.history.current.path,
            customOptions:  [
            {
                'value': 'True', 
                'text': 'True'
            },{
                'value': 'False',
                'text': 'False'
            }],
            columns: [
            {
                name: 'name',
                label: 'Name',
                sortable: true,
                editable:false,
                render(row) {
                    return row.attributes.name;
                }
            },{
                name: 'value',
                label: 'Value',
                sortable: false,
                editable:true,
                render(row) {
                    if(row.attributes.name == 'Dashboard_Password')
                    {
                        return '*****';
                    }
                    else
                    {
                        return row.attributes.value;
                    }
                }
            }],
            columnlabel:"",
            dashboardcolumns: [{
                name: 'name',
                sortable: false,
                editable:false,
                render(row) {
                    return row.name;
                }
            },{
                name: 'timestamp',
                sortable: false,
                editable:false,
                render(row) {
                    return row.timestamp;
                }
            },{
                name: 'status',
                sortable: false,
                editable:false,
                displayComponent:StatusColumn,
            },{
                name: 'text',
                sortable: false,
                editable:false,
                render(row) {
                    return row.text;
                }
            }]
            ,
            dashboardactions:[{
                name: 'verify',
                label: 'Verify Status',
                callback: this.onVerifyDashboardNotification
            },{
                name: 'start',
                label: 'Start Notifications',
                callback: this.onStartDashboardNotification
            },{
                name: 'stop',
                label: 'Stop Notifications',
                callback: this.onStopDashboardNotification
            }],
            dashboarddata: [],
        }
    },

    props: ['group'],

    computed: {
        ecmDeshboardSettings() {
            var group = this.$parent.$root._router.history.current.meta.name;
            return this.configs.filter((t) => { if(t.attributes.group === group)
                return [t.attributes.name, t.attributes.value]; 
            this.configs.sort(sortOn('name', this.sortDir));
            });
        },
    },

    methods: {
        editRule(row,rowNumber) {
            row.editAction
        },

        refresh() {
            this.loaded = true;
        },

        sort(colNumber, dir) {
            var that = this;
            that.sortDir = dir;
            that.configs.sort(sortOn('name', dir));
        },
        
        save(element) {
            var that = this;
            that.$snotify.info(that.ecmResourceStrings.txtStartSaving);
            const value = element.attributes.value;
            var configvalue = "";
            if(value.trim().length > 0)
            {
                configvalue = JSON.stringify(value); 
                //configvalue = configvalue.replace(/"/g, ""); 
                configvalue = configvalue.replace(/"/ , ""); 
                configvalue = configvalue.replace(/"$/,"");
            }
            
            const configstring = '{"name": "' + element.attributes.name +'", "value": "' + configvalue +'"}';
            const connString = '{"settingDetails":[' + configstring + ']}';
            axios.put('/mtm-gateway-api/v1/services/ecm/config', connString,
                 {headers: {"Content-Type": "application/json; charset=UTF-8"}})
            .then((res) => {
                that.$snotify.clear();
                that.$snotify.success(that.ecmResourceStrings.txtECMConfigSettingsSaved);
            })
            .catch((err) => {
                if(element.options && element.options.attributes)
                    element.attributes.value = element.options.attributes.value;
                that.showError(err, 'save');
            });    
        },
        
        showError(err, location)
        {            
            const sTitle=this.ecmResourceStrings.ttlEcmConfigSetting;
            this.$snotify.clear();
            if(err.response)
            {
                if(err.response.data)
                {
                    this.$snotify.error(err.response.statusText, this.ecmResourceStrings.txtError, {
                        buttons: [
                            {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this.$parent, 'error', sTitle, err.response.statusText, true, err.response.data), bold: true },
                        ],
                    });
                }
                else if(err.message)
                {
                    this.$snotify.error(err.response.statusText, this.ecmResourceStrings.txtError, {
                        buttons: [
                            {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this.$parent, 'error', sTitle, err.response.statusText, true, err.message), bold: true },
                        ],
                    });
                }
                else
                {
                    this.$snotify.error(err.response.statusText, this.ecmResourceStrings.txtError, {
                        buttons: [
                            {text: this.ecmResourceStrings.txtViewDetails, action:()=>showMessage(this.$parent, 'error', sTitle, err.response.statusText, false, ''), bold: true },
                        ],
                    });
                }
            }
            else
            {
                this.$snotify.error(this.ecmResourceStrings.errEcmConfigSetting);
            }
        },

        onVerifyDashboardNotification()
        {
            var that = this;
            that.updateDashboardState(true,  "verify");
        },
        
        onStartDashboardNotification()
        {
            var that = this;
            
            //here we will check if variable NotificationEnabled == true
            //if it false, do not even start to run
            //give a message
            if(that.configs)
            {
                for(var i=0; i<that.configs.length; i++)
                {
                    const child = that.configs[i].attributes;
                    if(child.name == "Notification_Enabled")
                    {
                        const val = child.value;
                        if(val == "False")
                        {
                            showMessage(this, 'info', that.ecmResourceStrings.ttlDashboardNotificationState,'', true, that.ecmResourceStrings.msgDashboardDisabled);
                            return;
                        }
                    }
                }
            }
            that.dashboarddata[0].status ="Working";
            that.dashboarddata[0].text ="Working";
            that.dashboarddata[0].timestamp="";
            const connString=that.createBodyPostString("RunDashboardNotification");
            axios.post('/mtm-gateway-api/v1/services/ecm/actions/CrawlerExecuteProcess', connString, 
                {headers: {"Content-Type": "application/json; charset=UTF-8"}})
                .then((res) => {
                    if (res.data && res.data.crawlerOperationDetails[0]) {
                        setTimeout(that.updateDashboardState(true,  "start"),20000);
                    }
                })
                .catch((err) => {
                    //verify
                    /* 
                        .dashboardcannotstart;
                    */
                    //can not get status at all
                    that.dashboarddata[0].status ="CommunicationError";
                    that.dashboarddata[0].text =err.response.statusText;
                    const d = new Date();
                    that.dashboarddata[0].timestamp="on " + d;
                    //todo
                    showMessage(this, 'info', that.ecmResourceStrings.ttlDashboardNotificationState,err.response.statusText, true, err.response.data);
                    that.updateDashboardState(false,  "verify");
            });             
        },

        onStopDashboardNotification()
        {
            var that = this;
            that.dashboarddata[0].status ="Working";
            that.dashboarddata[0].text ="Working";
            const d = new Date();
            that.dashboarddata[0].timestamp="";
                                    
            const connString=that.createBodyPostString("StopExecution");
           
            axios.post('/mtm-gateway-api/v1/services/ecm/actions/CrawlerExecuteProcess', connString, 
                {headers: {"Content-Type": "application/json; charset=UTF-8"}})
                .then((res) => {
                    if (res.data && res.data.crawlerOperationDetails[0]) {
                        setTimeout(that.updateDashboardState(false , "stop"),20000);
                    }
                })
                .catch((err) => {
                    //verify todo
                    that.updateDashboardState(false,  "verify");
                });      
        },
                
        updateDashboardState(showmessage, camefrom)//action "verify", "start", "stop"
        {
            var that = this;
            that.dashboarddata[0].status ="Working";
            that.dashboarddata[0].text ="Working";
            that.dashboarddata[0].timestamp="";
            axios.get('/mtm-gateway-api/v1/services/ecm/actions/CrawlerExecuteProcess?ProcessName=RunDashboardNotification')
                .then((res) => {
                    if (res.data) {
                        if(res.data.crawlerExecuteProcessResultsDetails)
                        {
                            if(res.data.crawlerExecuteProcessResultsDetails[0].crawlerProcessResultsDetails == null)//no record
                            {
                                //not running
                                //let's go to check why is not running: was it stopped or error occurs that is why do not running
                                if(camefrom == 'start')
                                {
                                    showMessage(this, 'info', that.ecmResourceStrings.ttlDashboardNotificationState,'', true, that.ecmResourceStrings.msgDashboardStarting);
                                    that.getErrors(false,false);
                                }
                                else
                                {
                                    that.getErrors(false,false);
                                }
                            }
                            else
                            { //record in ProcessStatus table are exist
                                //running
                                //if it's running lets go to check if everything is OK
                                //new implementation 13.03 Henry add code to check if really engine running.
                                //if it was started and was reboot - tables didn't cleaned and incorrect status is here
                                if(res.data.crawlerExecuteProcessResultsDetails[0].executionResultsDetails[0])
                                {
                                    if(res.data.crawlerExecuteProcessResultsDetails[0].executionResultsDetails[0].executionStatusDetails == null)
                                    {
                                        that.dashboarddata[0].status ="NotRunning";
                                        that.dashboarddata[0].text ="Not Running";
                                        const d = new Date();
                                        that.dashboarddata[0].timestamp="on " + d;;
                                 
                                        if(showmessage == true)
                                        {
                                            showMessage(this, 'info', that.ecmResourceStrings.ttlDashboardNotificationState,'', true, that.ecmResourceStrings.msgDashboardNotRunning);
                                        }
                                    }
                                    else
                                    {
                                        that.getErrors(showmessage, true);
                                    }
                                }
                                else
                                {
                                    that.getErrors(showmessage, true);
                                }   
                            }
                        }
                        else{
                            //it means method on thin machine is not completed. never should be here, but just in case
                            that.dashboarddata[0].status ="CommunicationError";
                            that.dashboarddata[0].text ="No Info";
                            const d = new Date();
                            that.dashboarddata[0].timestamp="on " + d;
                        }
                }
            })
            .catch((err) => {
                //can not get status at all
                that.dashboarddata[0].status ="CommunicationError";
                that.dashboarddata[0].text =err.response.statusText;
                const d = new Date();
                that.dashboarddata[0].timestamp="on " + d;
                if(showmessage == true)
                {
                    showMessage(this, 'info', that.ecmResourceStrings.ttlDashboardNotificationState,err.response.statusText, true, err.response.data);
                }
            });
        },

        createBodyPostString(name)
        {
            var that = this;
            var configstring = "";
            var parameters = null;
            if(name =="StopExecution")
            {
                parameters = '[{ "name" : "shRepositoryId", "value" : "-110", "type" : "int","isNull" : false}, {"name" : "shPartitionId","value" : "0","type" : "int","isNull" : false},{"name" : "shCrawlerProcessId","value" : "Null","type" : "int","isNull" : true}]';
                configstring = '{"name": "' + name + '", "engineName": "1", "parameters": ' + parameters + ', "asynchronousExecution": false}';
            }
            else
            {
                //MTA-3890
                parameters = '[{"name" : "shCrawlerProcessId","value" : "Null","type" : "int","isNull" : true}]';
                configstring = '{"name": "' + name + '", "engineName": "1", "parameters": ' + parameters + ', "asynchronousExecution": true}';
            }
            return configstring;
        },
        
        getErrors:function(showmessage, running)
        {
            var that = this;
            axios.get('/mtm-gateway-api/v1/services/ecm/query/errorLog/-110')
                .then((res) => {
                    if (res.data) {
                        if(res.data.logDetails)
                        {
                            //errors are exists
                            const comp = res.data.logDetails[0].component;
                            const mess = res.data.logDetails[0].message;
                            const eachLine = mess.split('\n');
                            const lines = eachLine.length;
                            const main = eachLine[0];
                            var mesdata = '';
                            that.errorDescription ='';
                            if(mess)
                            {
                                if(main)
                                {
                                    if(main.length > 150)
                                    {
                                        mesdata="Error";
                                    }
                                else
                                {
                                    mesdata=main;
                                }
                            }
                            else
                            {
                                mesdata = mess;
                            }
                            var infotext;
                            if(comp)
                            {
                                infotext = that.ecmResourceStrings.errCcomponent + comp + that.ecmResourceStrings.errMessage + mesdata;
                            }
                            else
                            {
                                infotext = mesdata;
                            }  
                            that.dashboarddata[0].status ="Error";
                            that.dashboarddata[0].text =infotext;
                            const d = new Date();
                            that.dashboarddata[0].timestamp="on " + d;
                            if(showmessage == true)
                            {
                                showMessage(this, 'info', that.ecmResourceStrings.ttlDashboardNotificationState,'', true, mess);
                            }
                         }
                     }
                     else
                     { //running or not running with no errors
                        if(running == true)
                        {
                            that.dashboarddata[0].status ="Running";
                            that.dashboarddata[0].text ="Running";
                            const d = new Date();
                            that.dashboarddata[0].timestamp="on " + d;
                            if(showmessage == true)
                            {
                                showMessage(this, 'info', that.ecmResourceStrings.ttlDashboardNotificationState,'', true, that.ecmResourceStrings.msgDashboardRunning);
                            }
                        }
                        else
                        {
                            that.dashboarddata[0].status ="NotRunning";
                            that.dashboarddata[0].text ="Not Running";
                            const d = new Date();
                            that.dashboarddata[0].timestamp="on " + d;
                            if(showmessage == true)
                            {
                                showMessage(this, 'info', that.ecmResourceStrings.ttlDashboardNotificationState,'', true, that.ecmResourceStrings.msgDashboardNotRunning);
                            }
                        }
                    }
                }
            })
            .catch((err) => {
                //can not get status at all
                that.dashboarddata[0].status ="CommunicationError";
                if(err.response)
                {that.dashboarddata[0].text =err.response.statusText;
                }
                else{
                    that.dashboarddata[0].text="";
                }
                const d = new Date();
                that.dashboarddata[0].timestamp="on " + d;
                if(showmessage == true)
                {//todo
                    showMessage(this, 'info', that.ecmResourceStrings.ttlDashboardNotificationState,err.response.statusText, true, err.response.data);
                }
            });
        },
    },

    components: {
        SettingsTable,
        ECMErrorDialog
    },

    mounted() {
        var breadcrumbs = [{
            name: 'settings',
            meta: { label: 'Settings' }
        },{
            name: 'otic-config',
            meta: { label: 'Configurations' }
        },{
            name: this.path,
            meta: { label: this.tabname },
        }];

        this.$store.commit('breadcrumbs', breadcrumbs);
    },

    created() {
        var that = this;
        that.dashboarddata=[];
        that.dashboarddata.push({
            "name":that.ecmResourceStrings.lblDashboard,
            "timestamp":"",
            "status" : "",
            "text" : ""});
        that.updateDashboardState(false,  "verify");   
        that.ecmSettings.fetch({"Content-Type": "application/json; charset=UTF-8"})
            .then(() => {
                that.configs =  that.ecmSettings.resources;
                that.loaded = true;
            }
        )
        .catch((err) => {
            this.$snotify.clear();
            if(err.message)
            {
                this.$snotify.error(err.message, this.ecmResourceStrings.txtError);
            }
            else  if(err.response)
            {
                this.$snotify.error(err.response.data, this.ecmResourceStrings.txtError);
            }
            this.loaded = true;
        });
    }
}

</script>
